import { observer } from 'mobx-react-lite';

const RectangleButton = observer(
    ({ Icon, className, disabled, onClick, isActive, label }) => {
        return (
            <button
                disabled={disabled}
                onClick={onClick}
                className={`rectangle-button ${isActive ? 'active-rectangle-button' : ''} ${className} ${disabled ? 'disabled-rectangle-button' : ''}`}>
                {Icon}
                <span>{label}</span>
            </button>
        );
    },
);

export default RectangleButton;
